// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.questions {
  grid-template-columns: repeat(2, auto);
}
.notes-section {
  max-width: 100%;
}
.link {
  color: #5484ff;
  cursor: pointer;
}
.collapse-link i {
  color: black !important;
  float: right;
  padding-top: 5px;
}
.save-btn {
  margin-left: 15px !important;
}
mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
}
.docs-wrapper {
  width: 100% !important;
}
.modal-footer {
  padding: 2px !important;
}
.grid.verificationData {
  width: 100%;
  grid-template-columns: repeat(9, auto);
}
.grid.applicantData {
  width: 100%;
  grid-template-columns: repeat(6, auto);
}
h2.filter-title {
  width: 100%;
  display: block;
  text-align: center;
  background: #bfc3ce;
}
.table-wrapper {
  padding: 0 !important;
}
.form-check-input {
  padding: 12px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/employment-verification-form/employment-verification-form.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,eAAA;AAFJ;AAKA;EACI,cAAA;EACA,eAAA;AAHJ;AAMA;EACI,uBAAA;EACA,YAAA;EACA,gBAAA;AAJJ;AAOA;EACI,4BAAA;AALJ;AASA;EACE,SAAA;AAPF;AASA;EACI,aAAA;AAPJ;AAUA;EACI,yBAAA;EACA,uBAAA;AARJ;AAMA;EAKO,0BAAA;EACA,gBAAA;AARP;AAEA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AARP;AAYA;EACI,sBAAA;AAVJ;AAaA;EACI,uBAAA;AAXJ;AAcA;EACI,WAAA;EACA,sCAAA;AAZJ;AAeA;EACI,WAAA;EACA,sCAAA;AAbJ;AAgBA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAdJ;AAiBA;EAAgB,qBAAA;AAdhB;AAgBA;EACI,wBAAA;AAdJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.grid.questions {\n    grid-template-columns: repeat(2, auto);\n}\n\n.notes-section {\n    max-width: 100%;\n}\n\n.link {\n    color: @brblue;\n    cursor: pointer;\n}\n\n.collapse-link i {\n    color: black !important;\n    float: right;\n    padding-top: 5px;\n}\n\n.save-btn {\n    margin-left: 15px !important;\n}\n\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n    }\n}\n\n.docs-wrapper {\n    width: 100% !important;\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.grid.verificationData {\n    width:100%;\n    grid-template-columns: repeat(9, auto);\n}\n\n.grid.applicantData {\n    width:100%;\n    grid-template-columns: repeat(6, auto);\n}\n\nh2.filter-title{\n    width:100%;\n    display:block;\n    text-align: center;\n    background: #bfc3ce;\n}\n\n.table-wrapper{ padding: 0 !important;}\n\n.form-check-input {\n    padding: 12px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
